module.exports = obpa_dependencies;


//////////////////
// WEBPACK FOOTER
// external "obpa_dependencies"
// module id = 14
// module chunks = 0